import React, { useState } from "react";
import styled from "styled-components";

import { coreFourSubjectList } from "@examspark/common/dist/meta/assets";
import {
  AnalyticsEventName,
  NewClassroomModal,
  useAnalytics,
} from "@examspark/common-app";
import { Button, VSpace } from "@examspark/common-ui";
import { IconAddLine } from "@examspark/common-ui/dist/components/icons";
import { Subject } from "@examspark/types";

import classroomIcon from "../common/graphics/classroom.svg";

const SetupPrompt = styled.div`
  border: dashed 2px #ddd;
  border-radius: 0.5rem;
  padding: 5rem 3rem;
  /* align-items: center; */
  justify-content: center;
  display: flex;

  flex-direction: column;
  gap: 2rem;
`;
const SetupTitle = styled.div`
  font-size: 3rem;
  font-weight: 300;
  color: #333;
`;
const SetupText = styled.div`
  font-size: 1.3rem;
  color: #777;
`;
const SetupButton = styled.div``;

const StyledButton = styled(Button)`
  font-size: 1.8rem;
  height: 4rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

const ClassroomsSetupPrompt = (props: { onCreate?: () => void }) => {
  const [isNewSectionModalOpen, setIsNewSectionModalOpen] = useState(false);
  const analytics = useAnalytics();

  return (
    <>
      <NewClassroomModal
        isOpen={isNewSectionModalOpen}
        onRequestClose={() => setIsNewSectionModalOpen(false)}
        onCreate={() => {
          setIsNewSectionModalOpen(false);
          analytics.trackEvent(AnalyticsEventName.ClassroomCreate);
        }}
        hideCourseInput={false}
        hideSubjectInput={false}
        hideGradeInput={false}
        overrideSubjects={[...coreFourSubjectList, Subject.MultiSubject]}
      />
      <div>
        <SetupPrompt>
          <div>
            <img src={classroomIcon} alt="Classroom" />
          </div>
          <VSpace style={{ gap: "0.3rem" }}>
            <SetupTitle>Let's add your first classroom to TCMPC!</SetupTitle>
            <SetupText>
              Each classroom you create can individually track a TCMPC
              curriculum course for the duration of your school year.
            </SetupText>
          </VSpace>
          <SetupButton>
            <StyledButton
              color="create"
              title="New Classroom"
              icon={<IconAddLine />}
              onClick={() => setIsNewSectionModalOpen(true)}
            >
              Classroom
            </StyledButton>
          </SetupButton>
        </SetupPrompt>
      </div>
    </>
  );
};

export default ClassroomsSetupPrompt;
